export const URL = 'https://nsbackend.campaigns.fi';
//export const URL = 'http://localhost:3000';
